/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAccountLinkDto } from '../models/CreateAccountLinkDto';
import type { CreateConnectAccountDto } from '../models/CreateConnectAccountDto';
import type { CreatePaymentIntentDto } from '../models/CreatePaymentIntentDto';
import type { CreateSetupIntentDto } from '../models/CreateSetupIntentDto';
import type { PaymentResponse } from '../models/PaymentResponse';
import type { RefundDto } from '../models/RefundDto';
import type { StripeAccountDetailsResponse } from '../models/StripeAccountDetailsResponse';
import type { StripeAccountLinkResponse } from '../models/StripeAccountLinkResponse';
import type { StripeConnectAccountResponse } from '../models/StripeConnectAccountResponse';
import type { StripeCustomerResponse } from '../models/StripeCustomerResponse';
import type { StripeDashboardLinkResponse } from '../models/StripeDashboardLinkResponse';
import type { StripeDeleteResponse } from '../models/StripeDeleteResponse';
import type { StripePaymentIntentStatusResponse } from '../models/StripePaymentIntentStatusResponse';
import type { StripePaymentMethodResponse } from '../models/StripePaymentMethodResponse';
import type { StripeRefundResponse } from '../models/StripeRefundResponse';
import type { StripeWebhookResponse } from '../models/StripeWebhookResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StripeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a Stripe customer
     * Creates a Stripe customer for the authenticated client and saves the customer ID to their profile.
     * @returns StripeCustomerResponse Stripe customer created successfully.
     * @throws ApiError
     */
    public stripeControllerCreateCustomer(): CancelablePromise<StripeCustomerResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/customers',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Create a Stripe Connect account
     * Creates a Stripe Connect account for the authenticated society owner.
     * @returns StripeConnectAccountResponse Connect account created successfully.
     * @throws ApiError
     */
    public stripeControllerCreateConnectAccount({
        requestBody,
    }: {
        requestBody: CreateConnectAccountDto,
    }): CancelablePromise<StripeConnectAccountResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/connect',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Get Stripe account details
     * Returns details of a Stripe Connect account. Only admins and society owners can access.
     * @returns StripeAccountDetailsResponse Account details returned successfully.
     * @throws ApiError
     */
    public stripeControllerGetAccountDetails({
        id,
    }: {
        /**
         * Stripe Connect account ID
         */
        id: string,
    }): CancelablePromise<StripeAccountDetailsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/stripe/account/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Delete a Stripe account
     * Deletes a Stripe customer or Connect account. Supports both "cus_" prefixed customer IDs and "acct_" prefixed Connect account IDs. Only admins can delete accounts.
     * @returns StripeDeleteResponse Account deleted successfully.
     * @throws ApiError
     */
    public stripeControllerDeleteAccount({
        id,
    }: {
        /**
         * Stripe account ID (customer "cus_*" or Connect "acct_*")
         */
        id: string,
    }): CancelablePromise<StripeDeleteResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/stripe/account/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Create an onboarding link
     * Creates a Stripe Account Link for Connect onboarding. Optionally accepts custom refresh/return URLs that must match the allowed frontend origins whitelist. Only society owners can request this.
     * @returns StripeAccountLinkResponse Account link created successfully.
     * @throws ApiError
     */
    public stripeControllerCreateAccountLink({
        id,
        requestBody,
    }: {
        /**
         * Stripe Connect account ID
         */
        id: string,
        requestBody?: CreateAccountLinkDto,
    }): CancelablePromise<StripeAccountLinkResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/account-link/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Create a payment intent
     * Creates a Stripe PaymentIntent for an intervention. Only clients can initiate payments.
     * @returns PaymentResponse Payment intent created successfully.
     * @throws ApiError
     */
    public stripeControllerCreatePaymentIntent({
        requestBody,
    }: {
        requestBody: CreatePaymentIntentDto,
    }): CancelablePromise<PaymentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/payment-intent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * List saved payment methods
     * Lists all saved payment methods for the authenticated client. Only clients can access this.
     * @returns StripePaymentMethodResponse Payment methods returned successfully.
     * @throws ApiError
     */
    public stripeControllerListPaymentMethods(): CancelablePromise<Array<StripePaymentMethodResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/stripe/payment-methods',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Create a setup intent
     * Creates a Stripe SetupIntent to save a payment method for future use. Only clients can set up payment methods.
     * @returns PaymentResponse Setup intent created successfully.
     * @throws ApiError
     */
    public stripeControllerCreateSetupIntent({
        requestBody,
    }: {
        requestBody: CreateSetupIntentDto,
    }): CancelablePromise<PaymentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/setup-intent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Issue a refund
     * Issues a refund for a previous payment. Only admins can issue refunds.
     * @returns StripeRefundResponse Refund issued successfully.
     * @throws ApiError
     */
    public stripeControllerRefund({
        requestBody,
    }: {
        requestBody: RefundDto,
    }): CancelablePromise<StripeRefundResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/refund',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Get Stripe customer details
     * Returns details of a Stripe customer account.
     * @returns StripeAccountDetailsResponse Customer details returned successfully.
     * @throws ApiError
     */
    public stripeControllerGetCustomer({
        id,
    }: {
        /**
         * Stripe customer ID
         */
        id: string,
    }): CancelablePromise<StripeAccountDetailsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/stripe/customer/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Create a dashboard link
     * Generates a Stripe dashboard link for a Connect account. Only society owners can request this.
     * @returns StripeDashboardLinkResponse Dashboard link created successfully.
     * @throws ApiError
     */
    public stripeControllerCreateDashboardLink({
        id,
    }: {
        /**
         * Stripe Connect account ID
         */
        id: string,
    }): CancelablePromise<StripeDashboardLinkResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/dashboard-link/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Get payment intent status
     * Returns the current status of a payment intent. The client secret is accepted in the request body to avoid exposing it in URL paths and server logs.
     * @returns StripePaymentIntentStatusResponse Payment intent status returned successfully.
     * @throws ApiError
     */
    public stripeControllerGetPaymentIntentStatus({
        requestBody,
    }: {
        requestBody: {
            /**
             * Payment intent client secret
             */
            clientSecret: string;
        },
    }): CancelablePromise<StripePaymentIntentStatusResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/payment-intent-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid client secret format.`,
                401: `Unauthorized.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Stripe webhook handler
     * Receives and processes Stripe webhook events. This endpoint does not require authentication.
     * @returns StripeWebhookResponse Webhook received and processed.
     * @throws ApiError
     */
    public stripeControllerHandleWebhook(): CancelablePromise<StripeWebhookResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/stripe/webhook',
            errors: {
                400: `Invalid webhook signature.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
}
